import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "./admin/AdminSidebar";
import { SHOW_RFID_MAPPING } from "../config/attendanceFeatures.js";

// Menu dashboard Attendance & Grading. Tampilan sidebar ada di
// admin/AdminSidebar.js (aksen teal lewat variant "attendance").
const ITEMS = [
  { path: "/attendance/dashboard", label: "Dashboard", icon: "bi-house" },
  { path: "/attendance/sessions", label: "Class Sessions", icon: "bi-calendar3" },
  ...(SHOW_RFID_MAPPING
    ? [{ path: "/attendance/rfid-mapping", label: "RFID Mapping", icon: "bi-credit-card-2-front" }]
    : []),
  { path: "/attendance/grid", label: "Attendance Grid", icon: "bi-grid-3x3" },
  { path: "/attendance/catchup", label: "Catchup Videos", icon: "bi-play-btn" },
  { path: "/attendance/grading", label: "Assignment Grading", icon: "bi-clipboard-check" },
  { path: "/attendance/report", label: "Report & Graduation", icon: "bi-mortarboard" },
  { path: "/attendance/assistants", label: "Class Assistants", icon: "bi-people" },
];

const SidebarAttendance = ({ isMobileAdmin }) => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await axios.delete("/logoutAdmin");
    } catch (error) {
    } finally {
      navigate("/loginAdmin");
    }
  };

  return (
    <AdminSidebar
      items={ITEMS}
      variant="attendance"
      switchButton={{ label: "Switch to Main", path: "/dashboardadmin" }}
      onLogout={logout}
      isMobileAdmin={isMobileAdmin}
    />
  );
};

export default SidebarAttendance;
